<template>
<div 
  class="card card--transparent card--course"
  :style="background" @click="$emit('click')">
  <div class="align-center" >
    <div>
      <h2>{{course.title}}</h2>
    </div>
    <div class="small-top description">{{course.description}}</div>
  </div>
      <span v-if="!loading" class="col" style="position: absolute; bottom: 5px; right: 5px">
        <span style="padding: 10px" @click.stop="moveUp">
          <h-icon>keyboard_arrow_up</h-icon>
        </span>
        <span style="padding: 10px" @click.stop="moveDown">
          <h-icon>keyboard_arrow_down</h-icon>
        </span>
      </span>
      <span v-else class="col" style="position: absolute; bottom: 5px; right: 5px">
       <v-progress-circular
        color="orange"
        height="10"
        :value='10'
        indeterminate
        ></v-progress-circular>
      </span>
</div>
</template>

<script>
export default {
  props: ["img", "course", "loading"],
  data() {
    return {
      background: {position: 'relative', 'background-image': `linear-gradient(rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)), url(${this.img})`} 
    }
  },
  methods: {
    moveUp() {
      this.$emit('move', -1)
    },
    moveDown() {
      this.$emit('move', 1)
    }
  }
}
</script>

<style lang="less" scoped>
.card--course {
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  padding: 1em;
  width: 32%;
  height: 40vh;

  .description {
    overflow-y: auto;
    max-height: 100%;
  }

  @media (max-width: 1000px) {
    width: 48%;
  }

  h2 {
    text-transform: none;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
  .align-center {
    display: flex;
    flex-direction: column;
    > * {
      text-align: center;
    }
  }
}
</style>
